export enum LoginPrefillReason {
  USER_ACTIVATION = 'userActivation',
  PASSWORD_RESET = 'passwordReset',
}
